"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.momentStartTime = void 0;

var _getProperty = require("../../../../util/getProperty");

/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Brian Bal
 */

/**
 * returns the utc start time of the moment in seconds
 *
 * @param {*} moment - the moment object
 * @return {number} - the utc start time in seconds
 */
var momentStartTime = function momentStartTime(moment) {
  var utc = (0, _getProperty.getProperty)("start_time", moment, null);

  if (!utc) {
    utc = (0, _getProperty.getProperty)("utc_time", moment, null);
  }

  var offset = (0, _getProperty.getProperty)("dynamic_offset", moment, null);

  if (!offset) {
    offset = (0, _getProperty.getProperty)("meta.dynamic.offset", moment, null);
  }

  return utc / 1000 - offset;
};

exports.momentStartTime = momentStartTime;